module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAG1BMVEVHcEz///////////////////////////////8W/R0OAAAACHRSTlMAHzVNFeWIwQVy4eMAAAENSURBVHjatZdBDsMgDARjGxL+/+LmNhKy1eJV51h1FkwSMFeJ+Uu8+Itdh5jHhptgk9HTwcdXfaC3ItBL/Kqx+InRHB689KWEOKI5Pnhz/cC2xx/HjF4B4JJPAgUoRXi0cCbQZDABaQoWbYwJ9PBqBea8Y+OeT7EKlgWsdW/+WrOowQP4Own8UNQQsAm1D1kFKKUPllWAVPngZQAa/kEAIv5RAAn4RUBAmoCfQ0CagP+3ALkEcRH1x6i/SPKrLH9M6uesbyj6lpbW8GSbahYgb+vywaIfbdoUTD3e5QZDb3Gg4w+xzTPsVhGut7p6s623++2G2zo3LvAhXrr+du0jQtDFqy8MMrDz0eXr/wcqeCjlQjQ8iwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ky-close.png
// module id = qDbJ
// module chunks = 216